const WILLS_COMPLETED_STEPS_KEY = 'wills-completed-steps';

function canUseStorage(): boolean {
  return typeof window !== 'undefined' && !!window.localStorage;
}

export function getCompletedWillsSteps(): string[] {
  if (!canUseStorage()) return [];

  try {
    const raw = window.localStorage.getItem(WILLS_COMPLETED_STEPS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === 'string') : [];
  } catch (error) {
    console.error('Failed to read completed wills steps from localStorage', error);
    return [];
  }
}

export function addCompletedWillsStep(stepName: string): void {
  if (!canUseStorage() || !stepName) return;

  try {
    const completedSteps = getCompletedWillsSteps();
    if (completedSteps.includes(stepName)) return;
    window.localStorage.setItem(
      WILLS_COMPLETED_STEPS_KEY,
      JSON.stringify([...completedSteps, stepName])
    );
  } catch (error) {
    console.error('Failed to save completed wills steps to localStorage', error);
  }
}

export function isWillsStepCompleted(stepName: string): boolean {
  if (!stepName) return false;
  return getCompletedWillsSteps().includes(stepName);
}

export function clearCompletedWillsSteps(): void {
  if (!canUseStorage()) return;

  try {
    window.localStorage.removeItem(WILLS_COMPLETED_STEPS_KEY);
  } catch (error) {
    console.error('Failed to clear completed wills steps from localStorage', error);
  }
}
